<template>
  <div class="review">
    <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteWebinarReview(review.id)"/>
    <div class="review-block">
      <div class="columns">
        <span class="column review-name">{{review.name}}</span>
        <span class="review-date column">{{review.date}}</span>
      </div>
      <span class="review-text">{{review.text}}</span>
    </div>
    <div class="review-block webinar-info">
      <span>{{review.webinar.date}}</span>
      <span>{{review.webinar.theme}}</span>
      <span v-if="review.webinar.webinarSpeaker && review.webinar.webinarSpeaker.name"> Спикер: {{review.webinar.webinarSpeaker.name}}</span>
    </div>
    <div v-if="!review.isPublished" class="publish" @click="publishWebinarReview(review.id)">
      Опубликовать
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'WevinarReviewItem',
  data () {
    return {
    }
  },
  props: {
    review: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteWebinarReview', 'publishWebinarReview'])
  }
}
</script>

<style scoped>
.review span {
  display: block;
}
.review {
  margin: 25px 0;
  position: relative;
}
.review-block {
  background: #eee;
  padding: 15px 25px;
  margin-top: 5px;
}
.webinar-reviews {
  max-width: 800px;
  margin: 0 auto;
}
.review-date {
  text-align: right;
}
.review-name {
  font-weight: bold;
}
.review-text {
  margin: -15px 0 0;
}
.webinar-info {
  font-size: .9em;
}
.delete-icon {
  right: -13px;
  top: -13px;
}
.publish {
  background: #72bb53;
  color: white;
  text-align: center;
  padding: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// WebinarReviewItem.vue?a030e6a2